import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type FeedbackQuestionFragment = { id: string, description?: string | null, questionText?: string | null, questionType: Types.QuestionTypeEnum, settings?: { ratingScale?: number | null } | null };


export type FeedbackQuestionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type FeedbackQuestionsFragment = { id: string, type: Types.FeedbackQuestionTypeEnum, questions: Array<{ id: string, description?: string | null, questionText?: string | null, questionType: Types.QuestionTypeEnum, settings?: { ratingScale?: number | null } | null }> };


export type FeedbackQuestionsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const FeedbackQuestionFragmentDoc = /*#__PURE__*/ gql`
    fragment FeedbackQuestion on QuestionType {
  id
  description
  questionText
  questionType
  settings {
    ratingScale
  }
}
    `;
export const FeedbackQuestionsFragmentDoc = /*#__PURE__*/ gql`
    fragment FeedbackQuestions on FeedbackQuestionType {
  id
  type
  questions {
    ...FeedbackQuestion
  }
}
    `;